import useSWR from 'swr';
import {
	getGuidelines,
	getPaymentMethods,
	getStoredData,
	getTermsOfMonitoring,
} from './monitoringService';
import { useMonitoringStore } from './monitoringStore';

import { TermsOfMonitoring } from 'types/monitoring';

export function useGuidelines(slug: 'monitoring' | 'express') {
	const { setGuidelines } = useMonitoringStore();

	const { data, error, isLoading } = useSWR<any>(`guidelines/${slug}`, () => getGuidelines(slug), {
		onSuccess: (guideLines) => {
			setGuidelines(slug, guideLines);
		},
		revalidateOnFocus: true,
		revalidateIfStale: true,
		revalidateOnMount: true,
	});

	return { data, error, isLoading };
}

export function useGetTermsOfMonitoring() {
	const { setTermsOfMonitoring } = useMonitoringStore();

	const swrResponse = useSWR<TermsOfMonitoring>('termsOfMonitoring', getTermsOfMonitoring, {
		onSuccess: (termsOfMonitoring) => {
			setTermsOfMonitoring(termsOfMonitoring);
		},
		revalidateOnFocus: false,
		revalidateOnMount: true,
		revalidateIfStale: false,
	});

	return swrResponse;
}

export function useGetPaymentMethods() {
	const { paymentMethods, setPaymentMethods } = useMonitoringStore();

	const swrResponse = useSWR<any>(
		paymentMethods?.length ? null : 'paymentMethods',
		getPaymentMethods,
		{
			onSuccess: (fetchedPaymentMethods) => {
				setPaymentMethods(fetchedPaymentMethods);
			},
		}
	);

	return {
		data: paymentMethods || swrResponse.data,
		isLoading: swrResponse.isLoading,
		error: swrResponse.error,
	};
}
export function useGetStoredData(id: number | string | null) {
	const { setStepsDraft, stepsDraft } = useMonitoringStore();

	const swrResponse = useSWR<any>(
		id ? ['storedData', id] : null,
		() => getStoredData(id as number | string),
		{
			onSuccess: (data) => {
				// Only update state if the data is different to prevent infinite loops
				const currentData = stepsDraft?.packages;
				const newData = data;
				
				// Simple deep comparison using JSON.stringify
				if (JSON.stringify(currentData) !== JSON.stringify(newData)) {
					setStepsDraft({ packages: data });
				}
			},
			revalidateOnFocus: false,
			revalidateIfStale: false,
			revalidateOnMount: true,
		}
	);

	return swrResponse;
}
